import Timelapse from './timelapse'
import { Slider, SliderItem } from './slider';

export default {
	name: 'Highlights',
	components: {
		Slider,
		SliderItem,
		Timelapse
	},
	data() {
		return {
			current: 1
		}
	},
	methods: {
		nextHighlight() {
			let current = this.$refs.slider.currPage
			let numPages = this.$refs.slider.numPages

			let nextPage = current + 1;

			if (nextPage > numPages) {
				nextPage = 1;
			}

			this.$refs.slider.currPage = nextPage
		},
	}
}
